import clsx from "clsx";

interface SidePanelMenuItemProps {
  description: string;
  iconName?: string;
  href: string;
  isActive?: boolean;
}

const SidePanelMenuItem = ({
  description,
  iconName,
  href,
  isActive,
}: SidePanelMenuItemProps) => {
  return (
    <a
      data-rb-event-key="overview"
      className={clsx(
        "flex items-center gap-2 px-5 py-3 !no-underline text-label-2 rounded-lg w-full",
        "hover:bg-turquoise-dark-2 hover:text-turquoise-primary",
        "transition-colors duration-200",
        {
          "bg-turquoise-dark-2 text-turquoise-primary": isActive,
          "bg-black text-grey-light": !isActive,
        }
      )}
      role="button"
      tabIndex={0}
      href={href}
    >
      {iconName && <span className={iconName}></span>}
      <span>{description}</span>
    </a>
  );
};

export default SidePanelMenuItem;
